<template>
  <div v-if="!showNewActivityBar">
    <activity-bar :dataSources="'bcop'" :sensors="sensors" :customGuideList="customGuideList" @jumpLink="jumpLink" ></activity-bar>
  </div>
  <div v-else>
    <activity-bar-float :dataSources="'bcop'" :sensors="sensors" :customGuideList="customGuideList" @jumpLink="jumpLink" :isScrolling="isScrolling" :buttonColor="buttonColor"></activity-bar-float>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ActivityBar from "../ActivityBar/index.vue"
import ActivityBarFloat from "../ActivityBarFloat/index.vue"
export default {
  name: "ActivityBars",
  components: {
    ActivityBar,
    ActivityBarFloat
  },
  props: {
    customGuideList: {
      type: Array,
      default: () => [],
    },
    pageConfigId: {
      type: String,
      default: '',
    },
    buttonColor: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showNewActivityBar: false,
      isScrolling:1, // 悬浮监听页面是否在滑动，1 表示无动画效果，2表示滑动，3表示停止
    };
  },
  computed: {
    ...mapState(["commonStore"]),
    isLogin() {
      return this.$store.getters.isLogin;
    },
    platform() {
      return this.commonStore.platform;
    },
    sensors() {
      return this.$sensors;
    },
    miniProgram(){
      return  this.commonStore.appType == 'weixin'
    }
  },
  mounted() {
    console.log(this.commonStore,'appType123');
    // 判断url参数，如果没有navtab=0参数，则用0219版本的老样式
      const currentQuery = window.location.search.split("?")[1];
      if(!!currentQuery && (currentQuery.indexOf('navtab=0') > -1 || currentQuery.indexOf('navtab%3D0') > -1 || currentQuery.indexOf('navtab%253D0')>-1)){
        this.showNewActivityBar = true
      }else {
        this.showNewActivityBar = false
      }
      window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    jumpLink(guide){
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_guide",
        contentType: "自定义引导",
        contentName: guide.text
      });
      if (this.isLogin){// 已登录
        let link;
        if(this.platform.includes("App")||this.platform.includes("APP")){
          link = this.generateAppUrl(guide.jumpLinkApp);
        } else if (this.miniProgram) {//微信环境
          let url = this.generateUrl(guide.jumpLinkWx)
          if(this.platform.includes("WX")){//微信公众号推送里，'weixin'微信环境51jobWX
            url = '/' + url
            this.$wx.miniProgram.navigateTo({ url });
          }else{//微信聊天消息中，'weixin'是51jobm
            if(this.platform.includes("yjs")){
              link = 'https://lego.51job.com/yjs.html?redirect=' +  encodeURIComponent(url)
            }else{
              link = 'https://lego.51job.com/mj.html?redirect=' +  encodeURIComponent(url)    
            }
            window.location.href = link
          }
          return;
        } else {
          link = this.generateUrl(guide.jumpLinkH5);
        }
        if (link) {
          window.location.href = link;
        }
      } else {// 未登录
        this.$base.toLogin();
      }
    },
    generateUrl(baseUrl) {
      if(!baseUrl){
        return ''
      }else{
        const newParams = `sourceId=${this.pageConfigId}&platform=${this.platform}&miniProgram=${this.miniProgram}`;
        // 检查URL是否已经有查询参数
        const hasExistingParams = baseUrl.includes('?');
        const separator = hasExistingParams ? '&' : '?';
        // 拼接新的URL
        let newUrl = `${baseUrl}${separator}${newParams}`;
        console.log(newUrl, 'generateUrl');
        return newUrl;
      }
    },
    generateAppUrl(jumpLinkApp){//拼接url的参数后，替换appScheme中的url
      // let jumpLinkApp = "qiancheng://home/show_webpage?fullscreen=1&url=https%3A%2F%2Factivity.51job.com%2Fop%2F1889857947332435969";
      // 查找"?"的位置，并获取查询字符串部分
      let queryString = jumpLinkApp.split('?')[1];
      if (queryString) {
          // 使用URLSearchParams处理查询字符串（注意：此处我们并未真正创建一个URL对象，而是模拟处理）
          let params = new URLSearchParams(queryString);
          console.log(params,params.get('url'),'params111');
          let baseUrl = params.get('url')//取出Scheme中url参数的值
          let newUrlValue = this.generateUrl(baseUrl,'app')//修改url参数的值
          // 设置新的url参数值
          params.set('url', newUrlValue);
          // 重新构造查询字符串
          let newQueryString = params.toString();
          // 替换原URL中的查询字符串部分
          let newLink = jumpLinkApp.split('?')[0] + '?' + newQueryString;
          console.log(newLink,'最终appScheme');
          return newLink
      } else {
          console.log("URL中没有查询字符串部分");
      }
    },
    handleScroll() {
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (this.scrollTop > 0) {
        this.isScrolling = 2;

        // 清除之前的定时器
        if (this.scrollTimeout) {
          clearTimeout(this.scrollTimeout);
        }

        // 设置一个定时器，在滚动停止后设置 isScrollingFooter 为 3，即停止
        this.scrollTimeout = setTimeout(() => {
          this.isScrolling = 3;
        }, 600); // 600ms 内没有新的滚动事件则认为滚动停止

    }
  },
},
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="less" scoped></style>
